import React from "react";
import { useAuth } from "contexts/authContext";

import { Route, Redirect } from "react-router-dom";

type Props = {
  component: any;
  bypassRole?: boolean;
  path: string;
  exact?: boolean;
};

const GuestRoute: React.FC<Props> = (props) => {
  const { isAuthenticated } = useAuth();

  const { component: Component, ...rest } = props;

  return (
    <Route
      {...rest}
      render={(props: any) =>
        !isAuthenticated ? <Component {...props} /> : <Redirect to="/home" />
      }
    />
  );
};

export { GuestRoute };
